import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile } from 'react-device-detect';
import MyButton from 'components/form/MyButton';
import MyInput from 'components/form/MyInput';
import MySelect from 'components/form/MySelect';
import MySelectCheckbox from 'components/form/MySelectCheckbox';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CHANGE_EQUIPMENT_FILTER } from 'constants/constants';
import {
  Grid, InputAdornment, IconButton
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const EquipmentsActions = (props) => {
  const filters = useSelector(state => state.filter);
  const [searchValue, setSearchValue] = useState(filters.search);
  const alarmesValues = [
    { value: 0, label: 'Tous les équipements (sans filtre)' },
    { value: 1, label: 'Avec au moins une alarme active' },
    { value: 2, label: 'Avec au moins une alarme active non acquittée' },
    { value: 3, label: 'Avec au moins une alarme active (que des alarmes acquittées)' },
    { value: 4, label: 'Uniquement les équipements hors exploitation' },
  ];
  const dispatch = useDispatch();
  const auth = useSelector(state => state['authentification']);

  useEffect(() => {
    setSearchValue(filters.search);
  }, [filters.search]);

  const changeSelectValue = (v) => {
    dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, alarmType: v.value } });
  };
  const changeSelectFamilyValue = (event, value) => {
    const all = [];
    if (!value.includes('Toutes')) {
      props.equipmentFamily.forEach(element => {
        if (value.includes(element)) {
          all.push(element);
        }
      });
      dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, familyEquipment: all } });
    } else {
      dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, familyEquipment: [] } });
    }
  };
  const changeSelectAutorouteValue = (event, value) => {
    const all = [];
    if (!value.includes('Toutes')) {
      props.equipmentAutoroute.forEach(element => {
        if (value.includes(element)) {
          all.push(element);
        }
      });
      dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, autorouteEquipment: all } });
    } else {
      dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, autorouteEquipment: [] } });
    }
  };
  const changeSearchData = (e) => {
    setSearchValue(e.target.value);
  };
  const validSearchData = () => {
    dispatch({ type: CHANGE_EQUIPMENT_FILTER, value: { ...filters, 'search': searchValue } });
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.nativeEvent.code === 'Enter' || e.nativeEvent.code === 'NumpadEnter') {
      validSearchData();
    }
  };
  const handleOnLeave = (e) => {
    validSearchData();
  };

  return (
    <React.Fragment>
      {
        isMobile &&
        <div className='boutons-topbar-contenu'>
          <Grid container spacing={2} direction={'row'}>
            <Grid item xs={6} sm={2} md={2} lg={1} xl={1}>
              <MySelectCheckbox
                handleChange={changeSelectAutorouteValue}
                value={filters.autorouteEquipment}
                label={'Autoroutes'}
                datas={props.equipmentAutoroute}
                style={{ width: '100%' }}
                size='small'
                disabled={!props.wsStatus}
              />
            </Grid>
            <Grid item xs={6} sm={2} md={2} lg={1} xl={1}>
              <MySelectCheckbox
                handleChange={changeSelectFamilyValue}
                value={filters.familyEquipment}
                label={'Familles'}
                datas={props.equipmentFamily}
                style={{ width: '100%' }}
                size='small'
                disabled={!props.wsStatus}
              />
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={4} xl={4}>
              <MyInput
                handleChange={changeSearchData}
                onKeyPress={handleKeyPress}
                onLeave={handleOnLeave}
                value={searchValue || ''}
                label='Recherche'
                size='small'
                style={{
                  width: '100%'
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="search"
                      onClick={() => validSearchData()}
                      style={{
                        color: 'white'
                      }}
                    >
                        <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
                disabled={!props.wsStatus}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <MySelect
                handleChange={changeSelectValue}
                value={filters.alarmType || ''}
                label='Alarmes'
                datas={alarmesValues}
                style={{
                  width: '100%',
                  backgroundColor: !props.wsStatus ? '#8ca0a8' : '',
                }}
                disabled={!props.wsStatus}
              />
            </Grid>

          </Grid>
        </div>
      }
      {
        !isMobile &&
        <div className='boutons-topbar-contenu' style={{ width: '80%' }}>
          <MySelect
            handleChange={changeSelectValue}
            value={filters.alarmType || ''}
            label='Alarmes'
            datas={alarmesValues}
            style={{
              width: '45%',
              marginRight: '10px',
              backgroundColor: !props.wsStatus ? '#8ca0a8' : '',
            }}
            disabled={!props.wsStatus}
          />
          <MySelectCheckbox
            handleChange={changeSelectFamilyValue}
            value={filters.familyEquipment}
            label={'Familles équip.'}
            datas={props.equipmentFamily}
            style={{ width: '20%', marginRight: '10px' }}
            size='small'
            disabled={!props.wsStatus}
          />
          <MyInput
            handleChange={changeSearchData}
            onKeyPress={handleKeyPress}
            onLeave={handleOnLeave}
            value={searchValue || ''}
            label='Recherche'
            size='small'
            style={{ width: '30%' }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="search"
                  onClick={() => validSearchData()}
                  style={{
                    color: 'white'
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            disabled={!props.wsStatus}
          />
        </div>
      }
    </React.Fragment>
  );

};

export default EquipmentsActions;
